// we extend the scroll to behaviour so we can track if the window is still scrolling

const extendedScroll = () => {
  window.activeScrolls = ref<string[]>([]);
  window.isScrolling = ref<boolean>(false);
  const extendedScrollTo = function (fn: () => void) {
    return function () {
      window.activeScrolls.value.push('scroll');
      window.addEventListener(
        'scrollend',
        () => {
          window.activeScrolls.value.pop();
          window.isScrolling.value = window.activeScrolls.length > 0;
        },
        { once: true },
      );
      // eslint-disable-next-line prefer-rest-params
      return fn.apply(this, arguments);
    };
  };

  window.scrollTo = extendedScrollTo(window.scrollTo);
};

export default extendedScroll;
